import React from 'react';
import Portfolio from '../components/Portfolio';

import boston from '../img/work/cover1.jpg'
import yellowstone from '../img/work/cover2.jpg'
import grad from '../img/work/cover3.jpg'
import architecture from '../img/work/cover4.jpg'
import como from '../img/work/cover5.jpg'
import newengland from '../img/work/cover6.jpg'
import italy from '../img/work/cover7.jpg'
import coteazur from '../img/work/cover8.jpg'
import nice from '../img/work/cover9.jpg'
import summeralps from '../img/work/cover10.jpg'
import cars from '../img/work/cover11.jpg'
import interiors from '../img/work/cover12.jpg'
import nyc from '../img/work/cover13.jpg'
import winteralps from '../img/work/cover14.jpg'
import film from '../img/work/cover15.jpg'
import portraits from '../img/work/cover16.jpg'
import groups from '../img/work/cover17.jpg'
import hawaii from '../img/work/cover18.jpg'
import croatia from '../img/work/cover22.jpg'
import oslo from '../img/work/cover23.jpg'
import stockholm from '../img/work/cover24.jpg'
import denmark from '../img/work/cover25.jpg'
import netherlands from '../img/work/cover26.jpg'
import france from '../img/work/cover27.jpg'
import vienna from '../img/work/cover28.jpg'
import portugal from '../img/work/cover29.jpg'
import paris from '../img/work/cover30.jpg'
import canary from '../img/work/cover31.jpg'
import spain from '../img/work/cover32.jpg'
import greece from '../img/work/cover33.jpg'
import stays from '../img/work/cover34.jpg'

const ALL_DATA = [
  // places
  { id: 1,  imgSrc: coteazur,    coverName: "Côte D'Azur",      link: '/cotedazur',     category: 'places' },
  { id: 2,  imgSrc: winteralps,  coverName: 'Winter Alps',       link: '/winteralps',    category: 'places' },
  { id: 3,  imgSrc: greece,      coverName: 'Greece',            link: '/greece',        category: 'places' },
  { id: 4,  imgSrc: denmark,     coverName: 'Denmark',           link: '/copenhagen',    category: 'places' },
  { id: 5,  imgSrc: nice,        coverName: 'Nice',              link: '/nice',          category: 'places' },
  { id: 6,  imgSrc: como,        coverName: 'Lake Como',         link: '/como',          category: 'places' },
  { id: 7,  imgSrc: croatia,     coverName: 'Croatia',           link: '/croatia',       category: 'places' },
  { id: 8,  imgSrc: stockholm,   coverName: 'Stockholm',         link: '/stockholm',     category: 'places' },
  { id: 9,  imgSrc: boston,      coverName: 'Boston',            link: '/boston',        category: 'places' },
  { id: 10, imgSrc: paris,       coverName: 'Paris',             link: '/paris',         category: 'places' },
  { id: 11, imgSrc: netherlands, coverName: 'The Netherlands',   link: '/netherlands',   category: 'places' },
  { id: 12, imgSrc: nyc,         coverName: 'New York City',     link: '/newyorkcity',   category: 'places' },
  { id: 13, imgSrc: yellowstone, coverName: 'Yellowstone',       link: '/yellowstone',   category: 'places' },
  { id: 14, imgSrc: vienna,      coverName: 'Vienna',            link: '/vienna',        category: 'places' },
  { id: 15, imgSrc: france,      coverName: 'France',            link: '/france',        category: 'places' },
  { id: 16, imgSrc: spain,       coverName: 'Spain',             link: '/spain',         category: 'places' },
  { id: 17, imgSrc: portugal,    coverName: 'Portugal',          link: '/portugal',      category: 'places' },
  { id: 18, imgSrc: summeralps,  coverName: 'Summer Alps',       link: '/summeralps',    category: 'places' },
  { id: 19, imgSrc: oslo,        coverName: 'Oslo',              link: '/oslo',          category: 'places' },
  { id: 20, imgSrc: canary,      coverName: 'Canary Islands',    link: '/canaryislands', category: 'places' },
  { id: 21, imgSrc: newengland,  coverName: 'New England',       link: '/newengland',    category: 'places' },
  { id: 22, imgSrc: italy,       coverName: 'Italy',             link: '/italy',         category: 'places' },
  { id: 23, imgSrc: hawaii,      coverName: 'Hawaii',            link: '/hawaii',        category: 'places' },
  // people
  { id: 24, imgSrc: grad,        coverName: 'Graduation',        link: '/graduation',    category: 'people' },
  { id: 25, imgSrc: portraits,   coverName: 'Portraits',         link: '/portraits',     category: 'people' },
  { id: 26, imgSrc: groups,      coverName: 'Groups',            link: '/groups',        category: 'people' },
  // other
  { id: 27, imgSrc: architecture,coverName: 'Architecture',      link: '/architecture',  category: 'other'  },
  { id: 28, imgSrc: interiors,   coverName: 'Interiors',         link: '/interiors',     category: 'other'  },
  { id: 29, imgSrc: film,        coverName: 'Film',              link: '/film',          category: 'other'  },
  { id: 30, imgSrc: cars,        coverName: 'Cars',              link: '/cars',          category: 'other'  },
];

const Work = () => <Portfolio data={ALL_DATA} />;

export { Work };